import { Link } from 'react-router-dom';
import { FileText, ClipboardList } from 'lucide-react';
import { PanelCard, EmptyState } from '../../../components/ui';
import type { AcademicDashboardResponse } from '../../../api/types';
import { compactGrade, pct, signed } from './format';

const day = (iso: string) => new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });

export default function RecentExamsCard({ d, className = '' }: { d: AcademicDashboardResponse; className?: string }) {
  return (
    <PanelCard className={className} title="Recent exams" actions={<Link to="/exams/exam-list" className="text-[13px] font-semibold text-muted-2 no-underline hover:text-ink hover:underline">All →</Link>}>
      {d.recent_exams.length === 0 ? <EmptyState compact icon={<ClipboardList size={22} />} title="No exams in this window" /> : (
        <ul>
          {d.recent_exams.map((e) => (
            <li key={e.id} className="border-b border-hairline last:border-0">
              <Link to={`/exams/report/${e.id}`} className="flex items-center gap-3 py-[11px] text-ink no-underline hover:text-ink">
                <span className="grid h-9 w-9 flex-none place-items-center rounded-[12px] bg-mist text-slate-ink"><FileText size={18} strokeWidth={1.8} aria-hidden /></span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate font-semibold">{e.name}</span>
                  <span className="text-xs text-muted">{[compactGrade(e.grade), day(e.created)].filter(Boolean).join(' · ')} · {e.students_took} took</span>
                </span>
                <span className="text-right">
                  <span className="block font-mono font-semibold">{pct(e.avg_score)}</span>
                  <span className={`font-mono text-xs ${e.delta_vs_prior == null ? 'text-muted' : e.delta_vs_prior < 0 ? 'text-danger' : 'text-success'}`}>{signed(e.delta_vs_prior)}</span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </PanelCard>
  );
}
